export default __webpack_public_path__ + "static/media/logo_01.1b25bdd9.jpg";